webpackJsonp([67],{

/***/ "TTVH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-bitmap_c84a7ad215f7122205396f3e6a5bf213.html";

/***/ }),

/***/ "YS9K":
/***/ (function(module, exports, __webpack_require__) {

var SectionBitmap = (function () {
    function SectionBitmap() {
    }
    return SectionBitmap;
}());
angular.module('animatronApp.sectionBitmap', []).component('sectionBitmap', {
    bindings: {
        ltTitle: '<',
        description: '<'
    },
    controller: SectionBitmap,
    templateUrl: __webpack_require__("TTVH")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/67-28dc41a6a889e793a2e2.min.js